import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateOct = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / October`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#D1D7B3)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#D1D7B3)",
								stroke: "var(--sticker-dark,#5F6F27)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7383
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.8515 12.9921 C10.4676 12.9922 10.0995 12.9254 9.7475 12.7921 C9.4009 12.6588 9.0889 12.4668 8.8116 12.2161 C8.5395 11.9655 8.3236 11.6615 8.1636 11.3041 C8.0089 10.9468 7.9315 10.5441 7.9316 10.0961 C7.9315 9.6482 8.0088 9.2454 8.1635 8.8882 C8.3236 8.5309 8.5395 8.2268 8.8115 7.9761 C9.0888 7.7254 9.4009 7.5335 9.7475 7.4001 C10.0995 7.2668 10.4675 7.2001 10.8516 7.2001 C11.2355 7.2001 11.6036 7.2668 11.9556 7.4001 C12.3075 7.5335 12.6195 7.7255 12.8915 7.9761 C13.1689 8.2268 13.3876 8.5308 13.5476 8.8881 C13.7076 9.2455 13.7875 9.6481 13.7876 10.0961 C13.7875 10.5441 13.7076 10.9468 13.5475 11.3042 C13.3876 11.6615 13.1689 11.9655 12.8915 12.2161 C12.6195 12.4668 12.3075 12.6588 11.9555 12.7921 C11.6036 12.9254 11.2355 12.9921 10.8515 12.9921 Z M10.8516 11.8481 C11.1129 11.8482 11.3689 11.7841 11.6195 11.6561 C11.8702 11.5281 12.0755 11.3362 12.2356 11.0801 C12.4009 10.8188 12.4835 10.4908 12.4836 10.0961 C12.4835 9.6961 12.4008 9.3681 12.2356 9.1122 C12.0702 8.8508 11.8622 8.6588 11.6115 8.5361 C11.3608 8.4081 11.1076 8.3441 10.8515 8.3441 C10.5956 8.3441 10.3423 8.4081 10.0915 8.5361 C9.8463 8.6588 9.6409 8.8508 9.4756 9.1122 C9.3155 9.3681 9.2355 9.6961 9.2356 10.0961 C9.2355 10.4908 9.3156 10.8188 9.4756 11.0802 C9.6356 11.3362 9.8381 11.5282 10.0836 11.6562 C10.3342 11.7842 10.5902 11.8481 10.8516 11.8481 Z M16.8926 12.9921 C16.3113 12.9921 15.8153 12.8695 15.4046 12.6241 C14.994 12.3735 14.6793 12.0322 14.4606 11.6002 C14.2473 11.1681 14.1406 10.6721 14.1406 10.1122 C14.1406 9.5521 14.2446 9.0535 14.4526 8.6161 C14.6659 8.1734 14.9779 7.8268 15.3886 7.5762 C15.7992 7.3254 16.3006 7.2002 16.8926 7.2001 C17.586 7.2002 18.1566 7.3761 18.6046 7.7281 C19.0526 8.0747 19.3273 8.5682 19.4286 9.2082 L18.0446 9.2081 C17.9913 8.9361 17.8606 8.7255 17.6526 8.5761 C17.4499 8.4268 17.1885 8.3522 16.8686 8.3522 C16.5913 8.3521 16.3433 8.4188 16.1246 8.5522 C15.9059 8.6802 15.7352 8.8748 15.6126 9.1361 C15.4899 9.3921 15.4286 9.7175 15.4286 10.1121 C15.4286 10.4962 15.4873 10.8188 15.6046 11.0802 C15.7273 11.3361 15.898 11.5308 16.1166 11.6641 C16.3352 11.7921 16.586 11.8561 16.8686 11.8561 C17.1886 11.8561 17.4499 11.7895 17.6526 11.6561 C17.8606 11.5175 17.9913 11.3228 18.0446 11.0721 L19.4286 11.0721 C19.3273 11.6694 19.0526 12.1388 18.6046 12.4802 C18.1566 12.8215 17.5859 12.9922 16.8926 12.9921 Z M21.1262 12.8961 L21.1262 8.3841 L19.5182 8.3841 L19.5182 7.2961 L23.9982 7.2962 L23.9982 8.3842 L22.3821 8.3841 L22.3821 12.8962 L21.1262 12.8961 Z",
							id: `${__svgrId}-OCT`,
							style: { fill: "var(--sticker-dark,#5F6F27)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.153,
							y1: 19.1321,
							y2: 19.1321
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7503,
							x2: 17.7503,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.1461",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateOct;
